import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataChange } from '../../handsontable/types/data-change.interface';
import {
  ElementDescriptorInput,
  GetOuvrageByIdGQL,
  GetPageAtterrissageListingGQL,
  GetPageAtterrissageListingQueryVariables,
  GetRessourceNumeriqueListingGQL,
  UpdatePageAtterrissageGQL,
  UpdatePageAtterrissageMutationVariables,
  UpdateRessourceNumeriqueGQL,
  UpdateRessourceNumeriqueMutationVariables,
} from '../../../../graphql/generated';
import { MessageService } from 'primeng/api';
import { HotTableRegisterer } from '@handsontable/angular';
import { count, forkJoin, map, Observable, Subscription } from 'rxjs';
import { extractEdgesAndNodes } from '../../graphql/operators/extract-edges-and-nodes';
import { OuvrageService } from '../../services/ouvrage.service';
import { RessourcesNumeriquesComponent } from '../ressources-numeriques/ressources-numeriques.component';
import { PagesAtterissageComponent } from '../pages-atterissage/pages-atterissage.component';
import { ResumeOuvrageComponent } from '../../ouvrage/resume-ouvrage/resume-ouvrage.component';
import { UserService } from '../../services/user.service';
import { RessourcesNumeriquesService } from 'src/app/services/ressourcesNumeriques.service';
import { AppComponent } from '../../app.component';
import { DegradedModeService } from '../../services/degraded-mod-service';

@Component({
  selector: 'app-dashboard-ressources-numeriques',
  templateUrl: './dashboard-ressources-numeriques.component.html',
  styleUrls: ['./dashboard-ressources-numeriques.component.scss'],
})
export class DashboardRessourcesNumeriquesComponent implements OnInit {
  ouvrageId: number;
  public onLoadingRessourcesNumeriquesDone: boolean = false;
  public onLoadingPageAtterrissageDone: boolean = false;
  private pagesChanges: any = {};
  private RNChanges: any = {};
  private hotRegisterer = new HotTableRegisterer();
  private codeProjet: any;
  private ouvrageReforme: any;
  private shouldUpdateOuvrage: boolean = false;
  private shouldUpdatePages: boolean = false;
  private shouldUpdateRN: boolean = false;
  @ViewChild(RessourcesNumeriquesComponent)
  public ressourcesNumeriquesComponent: RessourcesNumeriquesComponent;
  @ViewChild(PagesAtterissageComponent)
  public pagesAtterrissagesComponent: PagesAtterissageComponent;
  @ViewChild(ResumeOuvrageComponent)
  public resumeOuvrageComponent: ResumeOuvrageComponent;
  ouvrage: any;
  statutOuvrage: any;

  constructor(
    private route: ActivatedRoute,
    private updatePageService: UpdatePageAtterrissageGQL,
    private pageService: GetPageAtterrissageListingGQL,
    private updateRNService: UpdateRessourceNumeriqueGQL,
    private messageService: MessageService,
    private ouvrageService: OuvrageService,
    private ouvrageServiceGQL: GetOuvrageByIdGQL,
    public userService: UserService,
    public ressourcesNumeriquesService: RessourcesNumeriquesService,
    public degradedModeService: DegradedModeService,
  ) {}

  ngOnInit() {
    const routeParams = this.route.snapshot.paramMap;
    this.ouvrageId = Number(routeParams.get('ouvrageId'));
    this.loadOuvrage();
  }

  loadOuvrage() {
    this.ouvrageServiceGQL
      .watch({ id: this.ouvrageId })
      .valueChanges.pipe(map((result) => result.data.getOuvrage))
      .subscribe({
        next: (value) => {
          this.ouvrage = value;
          this.statutOuvrage = this.ouvrage.statut;
        },
        error: (err) => {},
      });
  }

  saveAllChanges() {
    if (this.shouldUpdateRN && this.ressourcesNumeriquesComponent) {
      const invalidRows =
        this.ressourcesNumeriquesComponent.getInvalidStructureFolioRows();
      if (invalidRows.length > 0) {
        this.ressourcesNumeriquesComponent.displayValidationErrorModal(
          invalidRows,
        );
        return;
      }
    }

    if (this.shouldUpdateOuvrage) {
      this.saveOuvrage();
    }

    if (this.shouldUpdatePages) {
      this.savePagesChanges();
    }

    if (this.shouldUpdateRN) {
      this.saveRNChanges();
    }
  }

  updatePagesChanges($event) {
    if (Object.keys($event).length) {
      this.pagesChanges = $event;
      this.shouldUpdatePages = true;
    }
  }

  updateRNChanges($event) {
    if (Object.keys($event).length) {
      this.RNChanges = $event;
      this.shouldUpdateRN = true;
    }else{
      this.RNChanges = {};
      this.shouldUpdateRN = false;
    }
  }

  resetDatasetHistory(idTable) {
    if (!this.hotRegisterer.getInstance(idTable).isDestroyed) {
      this.hotRegisterer
        .getInstance(idTable)
        .getCellsMeta()
        .forEach((cellMeta) => {
          if (cellMeta.className?.toString().includes('edited-cell')) {
            cellMeta.className = cellMeta.className
              .toString()
              .replace(' edited-cell', '');
            this.hotRegisterer
              .getInstance(idTable)
              .setCellMetaObject(cellMeta.row, cellMeta.col, cellMeta);
          }
        });
      this.hotRegisterer.getInstance(idTable).render();
    }
  }

  exportIsi() {
    const idOuvrage = this.ouvrageId;
    this.ressourcesNumeriquesService.exportIsi(idOuvrage).subscribe({
      next: (data) => {
        let blob = new Blob([data.body]);
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = data.headers.get('filename');
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  private savePagesChanges() {
    var self = this;
    var entries = Object.entries(this.pagesChanges);
    let changesFunctions: Array<Observable<any>> = [];


    for (const entry of entries as Array<any>) {
      const changesFunction = new Observable((observer) => {
        var input = {};

        const value: Array<DataChange> = entry[1];
        const id = Number(entry[0]);

        value.forEach((element: DataChange) => {
          if (element.valid || element.column === 'actif') {
            var column = element.column;
            input[column] = element.value;
          }
        });

        const variables: UpdatePageAtterrissageMutationVariables = {
          id: id,
          input: input,
        };

        self.updatePageService.mutate(variables).subscribe({
          next: (value) => {
            if (value.data && value.data.updatePageAtterrissage) {
              if (value.data.updatePageAtterrissage.success) {
                observer.next();
                observer.complete();
              } else {
                observer.error(value.data.updatePageAtterrissage.message);
              }
            } else {
              observer.error('Pas de données détectées');
            }
          },
          error: (err) => {
            observer.error(err);
          },
        });
      });
      changesFunctions.push(changesFunction);
    }

    let ids = entries.map((entry) => Number(entry[0])).join(',');
    forkJoin(changesFunctions).subscribe({
      next: (value) => {
        self.shouldUpdatePages = false;
        self.messageService.add({
          key: 'update',
          severity: 'success',
          summary: 'Pages mises à jour',
        });
        self.resetDatasetHistory('pages');
        self.pagesAtterrissagesComponent.loadPageAtterrissage(ids);
        if(self.ressourcesNumeriquesComponent) {
          self.ressourcesNumeriquesComponent.loadPages(ids);
        }
      },
      error: (err) => {
        this.messageService.add({
          key: 'update',
          severity: 'error',
          summary: 'Erreur dans la mise à jour des pages : ' + err,
        });
      },
    });
  }

  private async saveRNChanges() {
    const changedIds = Object.keys(this.RNChanges);
    this.ressourcesNumeriquesService
      .updateAllRnChanges(this.RNChanges)
      .subscribe({
        next: (value) => {
          this.messageService.add({
            key: 'update',
            severity: 'success',
            summary: 'Ressources numériques mises à jour',
          });
          this.resetDatasetHistory('ressources_numeriques');
          this.ressourcesNumeriquesComponent.loadChangedRessourcesNumeriques(changedIds);
          this.resumeOuvrageComponent.loadOuvrage();
          //reset changes
          this.ressourcesNumeriquesComponent.dataChanges = this.RNChanges = [];
          this.shouldUpdateRN = false;
        },
        error: (err) => {
          console.log(err);
          this.messageService.add({
            key: 'update',
            severity: 'error',
            summary:
              'Erreur dans la mise à jour des ressources numériques : ' +
              err.error.detail,
          });
        },
      })
  }

  updateProjet($event: any) {
    console.log($event);
    switch ($event.type) {
      case 'CodeProjet':
        this.codeProjet = $event.value;
      break;
      case 'OuvrageReforme':
        this.ouvrageReforme = $event.value;
      break;
      default:
        break;
    }
    this.shouldUpdateOuvrage = true;
  }

  saveOuvrage() {
    this.ouvrageService
      .updateOuvrage(this.ouvrageId, this.codeProjet, this.ouvrageReforme)
      .subscribe({
        next: (data) => {
          this.messageService.add({
            key: 'update',
            severity: 'success',
            summary: data.toString(),
          });
          this.shouldUpdateOuvrage = false;
        },
        error: (err) => {
          if (err.error.message) {
            this.messageService.add({
              key: 'update',
              severity: 'error',
              summary: err.error.message,
            });
            // this.errors.push(err.error.message)
            // this.successMessage = ''
          }
          if (err.error.detail) {
            this.messageService.add({
              key: 'update',
              severity: 'error',
              summary: err.error.detail,
            });
            // this.errors.push(err.error.detail)
            // this.successMessage = ''
          }
        },
      });
  }

  reloadPages() {
    this.pagesAtterrissagesComponent.loadPageAtterrissage();
    this.ressourcesNumeriquesComponent.loadRessourcesNumeriques();
  }

  removePage(idPage: number): void {
    if(this.ressourcesNumeriquesComponent) {
       this.ressourcesNumeriquesComponent.removePage(idPage);
    }
  }

  exportOuvrageComplet() {
    const idOuvrage = this.ouvrageId;
    this.ouvrageService.exportOuvrage(idOuvrage).subscribe({
      next: (data) => {
        let blob = new Blob([data.body]);
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = data.headers.get('filename');
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  exportInov() {
    const idOuvrage = this.ouvrageId;
    this.ressourcesNumeriquesService.exportIinov(idOuvrage).subscribe({
      next: (data) => {
        let blob = new Blob([data.body]);
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = data.headers.get('filename');
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
